<span fxLayout="column" fxLayoutAlign="start center" class="w-100" fxLayoutGap="15px">

  <span fxLayout="row" fxLayoutGap="36px" *ngIf="sortedChannels.length > 0" class="w-100 iconlist">

    <div fxFlex="24px"><mat-icon class="fs24">supervisor_account</mat-icon></div>

    <span fxLayout="column" fxFlex="100%" fxLayoutGap="5px">


      <div fxFlex="24px"><b>{{'ytb.subscriber' | translate}}</b></div>

      <span class="mb1 w-100 " *ngFor="let channel of sortedChannels">
        <span fxLayout="row">
          <span fxFlex="80%">
            {{'ytb.'+channel.channelname | translate}}
          </span>
          <span fxFlex="20%" fxLayoutAlign="end">
            {{channel.subscribercount | number}}
          </span>
        </span>

      </span> <span class="mb1 bb-1-grey w-100 pb12px">

      </span>
    </span>
  </span>

  <span fxLayout="row" fxLayoutGap="36px" *ngIf="ytbesprechung?.hashtags.length > 0" class="w-100 iconlist">
    <div fxFlex="24px"><mat-icon class="fs24 pt4px">tag</mat-icon></div>
    <span fxLayout="row wrap" fxLayoutGap="5px" class="bb-1-grey w-100 pb12px">
      <mat-basic-chip [disableRipple]="true" *ngFor="let c of ytbesprechung?.hashtags"
        class="f-chip chip mb-1 outline clickable" (click)="handleChipClick(c)">
        {{'#' + c}}
      </mat-basic-chip>
    </span>
  </span>

  <span fxLayout="row" fxLayoutGap="36px" *ngIf="sortedChannels.length > 0 && ytbesprechung.rating.id >= 3"
    class="w-100 iconlist">
    <div fxFlex="24px"><mat-icon class="fs24 pt4px">insert_link</mat-icon></div>
    <span fxLayout="row wrap" fxLayoutGap="5px" class="w-100 pb12px">
      <span *ngFor="let channel of sortedChannels">
        <span fxLayout="row wrap" v fxLayoutGap="5px">
          <mat-basic-chip [disableRipple]="true" *ngIf="channel?.channeluri"
            class="f-chip chip mb-1 outline-none clickable"
            (click)="handleSocialMediaClick(channel, channel.channeluri)">
            {{'ytb.'+channel.channelname | translate}}
          </mat-basic-chip>
          <mat-basic-chip [disableRipple]="true" *ngIf="channel?.channelkidsuri"
            class="f-chip chip mb-1 outline-none clickable"
            (click)="handleSocialMediaClick(channel, channel.channelkidsuri)">
            {{'ytb.'+channel.channelname+'Kids' | translate}}
          </mat-basic-chip>

        </span>
      </span>
    </span>
  </span>

  <span fxLayout="row" fxLayoutGap="36px" *ngIf="sortedChannels.length > 0 && ytbesprechung.rating.id <= 2"
    class="w-100 iconlist">
    <div fxFlex="24px"><mat-icon class="fs24 pt4px">insert_link</mat-icon></div>

    <span fxLayout="column" class="f-hint-text">
      {{'besprechung.redYellowWarning' | translate}}
    </span>
  </span>





  <span fxLayout="row" fxLayoutGap="20px" fxLayout.xs="column" fxLayout.sm="column" class="w-100 iconlist">
    <span fxLayout="row">
      <span fxLayout="column" fxFlexOffset="60px">
        <span class="f-hint-text ">
          <span>{{'ytb.linkingHint' | translate}}</span>
          <a class="text-decoration-underline clickable black f-hint-link" routerLink="/redtext/101493/YouTube-TikTok-Instagram">
            {{'ytb.linkingHintLinkname' | translate}}</a>
          <span>.</span>
        </span>
        <span fxLayout="row" class="f-hint-text" fxLayoutGap="10px" fxFlexOffset="10px">
          <span fxLayout="row" fxLayoutGap="2px">
            <span>{{'ytb.date' | translate}}</span>
            <span>{{ytbesprechung.moddate | date }}</span>
          </span>
          <span (click)="openNoteModal()" class="text-decoration-underline clickable  f-hint-link">{{'ytb.disclaimer' |
            translate}}</span>
          <mat-icon class="custom-material-icon-info">info_outline</mat-icon>


        </span>
      </span>
    </span>
  </span>
